<div class="text-center mt-5">
  <fgbcl-loading></fgbcl-loading>
  <p class="mt-2 mb-0">
    <em [translate]="'subscriptions.payment-processing'">{{ 'cart.payment.processing' | translate }}</em>
  </p>
</div>
